<template>
  <div class="home-page">
    
    <el-dialog custom-class="vip-dialog" :close-on-click-modal="false" :show-close="false" :visible.sync="visible" width="50%">
      <div class="logo-diy">
          <img class="logo-head" src="@/assets/img/logo.png" alt="" />
        </div>
        <div class="title">
          WARNING: This platform hosts user-generated AI face-swap content that may include adult material (18+).
        </div>
        <!-- <div class="content">
          &nbsp;&nbsp;This website contains age-restricted materials, including content generated by AI, which may include nudity, explicit depictions of sexual activity, violence, and other mature themes. By entering, you affirm that you are at least 18 years of age or the age of majority in the jurisdiction you are accessing the website from and you consent to viewing such content.
        </div> -->
        <div class="content">
You MUST:<br />
Confirm you are 18+ and meet legal age requirements in your jurisdiction.
Agree NOT to upload/create:<br />
• Unauthorized use of religious figures<br />
• Violent, harmful, or infringing content<br />
• Material violating others' rights (e.g., likeness, copyright)<br />
• Other illegal/prohibited content<br />
Understand that:<br />
• You bear sole legal responsibility for your content<br />
• The platform assumes NO liability for user-uploaded material<br />
[ 🔞 I CONFIRM I AM 18+ & ACCEPT RESPONSIBILITY ]<br />
[ 🚫 EXIT ]<br />
        </div>
        <div class="btn">
          <div @click="handleOk" class="btn-enter">
            ENTER
          </div>
          <div @click="handleCancel" class="btn-exit">
            Exit
          </div>
        </div>
    </el-dialog>
    <el-dialog custom-class="vip-dialog" :close-on-click-modal="false" :show-close="false" :visible.sync="cancelVisible" width="50%">
      <div class="logo-diy">
          <img class="logo-head" src="@/assets/img/logo.png" alt="" />
        </div>
        <div class="title">
         This website is only applicable to users who have given their consent.
        </div>
        <div class="btn">
           <div @click="handleBack" class="btn-exit">
            Back
        </div>
        </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "index",
  components: {},
  data() {
    return {
     visible:true,
     cancelVisible:false
    };
  },
  mixins: [],
  mounted(){
    
  },
  methods: {
    handleOk(){
      this.visible = false;
      this.$router.push({ path: "/home" });
    },
    handleCancel(){
      this.visible = false;
      this.cancelVisible = true;
    },
    handleBack(){
      this.cancelVisible = false;
      this.visible = true;
    }
  },
};
</script>

<style lang="less" scoped>
.home-page { 
  font-family: Arial,Helvetica,sans-serif;
  color: #000000;
}
:deep .vip-dialog{
  border-radius: 30px;
  // background-color: #000000;
}
.logo-diy {
  height: 70px;
  width: 100%;
  background: linear-gradient(270deg, #9fc2ff 0%, #6000c1 100%);
  display: flex;
  justify-content:center;
  align-items: center;
    .logo-head {
      height: 20px;
      width: 200px;
      margin-left: 50px;
      cursor: pointer;
    }
  }
  .title {
    font-size: 40px;
    font-weight: 600;
    margin-top: 20px;
    margin-left: 50px;
    text-align: center;
    margin: 20px;
    white-space: normal;
    word-break: keep-all;
  }
  .content{
    font-size: 20px;
    white-space: normal;
    word-break: keep-all;
    line-height: 30px;
  }
  .btn{
    display: flex;
    justify-content: space-around;
    margin-top: 40px;
    .btn-enter{
      height: 50px;
      width: 300px;
      background: linear-gradient(270deg, #9fc2ff 0%, #6000c1 100%);
      border-radius: 10px;
      color: #ffffff;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      cursor: pointer;
    }
    .btn-exit{
      height: 50px;
      width: 300px;
      background: #000000;
      border-radius: 10px;
      color: #ffffff;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      cursor: pointer;
    }
  }
</style>
